import { Portal, Box, useColorModeValue } from '@chakra-ui/react';
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar, { SidebarResponsive } from 'components/sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';

import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from 'routes.js';

export default function Dashboard(props) {
  const { ...rest } = props;

  const SIDEBAR_FULL = 300;
  const SIDEBAR_COLLAPSED = 80;

  // 🔥 separate states
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const sidebarWidth = isCollapsed ? SIDEBAR_COLLAPSED : SIDEBAR_FULL;

  const getRoutes = (routes) =>
    routes.map((route, key) =>
      route.layout === '/admin' ? (
        <Route path={`${route.path}`} element={route.component} key={key} />
      ) : route.collapse ? (
        getRoutes(route.items)
      ) : null,
    );

  return (
    <SidebarContext.Provider
      value={{ isCollapsed, setIsCollapsed, isDrawerOpen, setIsDrawerOpen }}
    >
      {/* Desktop Sidebar */}
      <Sidebar routes={routes} {...rest} />

      {/* Content */}
      <Box
        ml={{ base: '0', xl: `${sidebarWidth}px` }}
        w={{ base: '100%', xl: `calc(100% - ${sidebarWidth}px)` }}
        minH="100vh"
        transition="all 0.25s ease"
        bg={useColorModeValue(
          'linear-gradient(to right, #eef2f3, #ffffff)',
          'linear-gradient(to right, #2c3e50,rgb(55, 117, 127))',
        )}
      >
        <Portal>
          <SidebarResponsive routes={routes} />
          <Navbar {...rest} />
        </Portal>

        <Box p="20px" pt="70px">
          <Routes>
            {getRoutes(routes)}
            <Route
              path="/"
              element={<Navigate to="/admin/dashboard" replace />}
            />
          </Routes>
        </Box>
      </Box>
    </SidebarContext.Provider>
  );
}
